import { render, staticRenderFns } from "./onlyCategory.vue?vue&type=template&id=16b3a78d&"
import script from "./onlyCategory.vue?vue&type=script&lang=js&"
export * from "./onlyCategory.vue?vue&type=script&lang=js&"
import style0 from "./onlyCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports